import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FiTrash2, FiMail } from "react-icons/fi";
import moment from "moment";
import AdminContainer from "../components/AdminContainer";
import AdminTitle from "../components/utils/AdminTitle";
import AdminToast from "../components/utils/AdminToast";
import messagesService from "../api/services/messages";

const MessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [toast, setToast] = useState(null);

  const loadMessages = async () => {
    try {
      const res = await messagesService.getMessages();
      setMessages(res.data || []);
    } catch (err) {
      setToast({ type: "error", message: err.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMessages();
  }, []);

  const handleDelete = async () => {
    try {
      await messagesService.deleteMessage(deleteId);
      setMessages((prev) => prev.filter((m) => m.id !== deleteId));
      setDeleteId(null);
      setToast({ type: "success", message: "Poruka je obrisana." });
    } catch (err) {
      setToast({ type: "error", message: err.message });
    }
  };

  return (
    <AdminContainer>
      {toast && (
        <AdminToast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      <AdminTitle kanji="信">Poruke sa sajta</AdminTitle>

      {loading ? (
        <l-line-spinner size="32" stroke="3" speed="1" color="#fe5f55" />
      ) : messages.length === 0 ? (
        <Empty>Nema pristiglih poruka.</Empty>
      ) : (
        <List>
          {messages.map((m) => (
            <MessageCard key={m.id}>
              <CardTop>
                <Email href={`mailto:${m.email}`}>{m.email}</Email>
                <Date>{moment(m.createdAt).format("DD.MM.YYYY HH:mm")}</Date>
                <DeleteBtn onClick={() => setDeleteId(m.id)}>
                  <FiTrash2 size={18} />
                </DeleteBtn>
              </CardTop>
              <Subject>{m.subject}</Subject>
              <Body>{m.message}</Body>
            </MessageCard>
          ))}
        </List>
      )}

      {deleteId && (
        <ModalOverlay onClick={() => setDeleteId(null)}>
          <ConfirmBox onClick={(e) => e.stopPropagation()}>
            <p>Da li si siguran da želiš da obrišeš ovu poruku?</p>
            <ModalActions>
              <Cancel onClick={() => setDeleteId(null)}>Odustani</Cancel>
              <Confirm onClick={handleDelete}>Obriši</Confirm>
            </ModalActions>
          </ConfirmBox>
        </ModalOverlay>
      )}
    </AdminContainer>
  );
};

export default MessagesPage;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-family: "Poppins-SemiBold";
  font-size: 1.8rem;
  color: #fff;
  margin-bottom: 1.6rem;
`;

const Empty = styled.div`
  font-family: "Poppins-Regular";
  font-size: 1.3rem;
  color: var(--muted, #8e8c94);
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  max-width: 820px;
`;

const MessageCard = styled.div`
  background: var(--bg1, #101013);
  border: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  border-radius: 0.9rem;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const CardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Email = styled.a`
  font-family: "Poppins-SemiBold";
  font-size: 1.3rem;
  color: #fe5f55;
  text-decoration: none;
  flex: 1;
  overflow-wrap: anywhere;
`;

const Date = styled.span`
  font-family: "Poppins-Regular";
  font-size: 1.1rem;
  color: var(--muted, #8e8c94);
  white-space: nowrap;
`;

const DeleteBtn = styled.div`
  display: flex;
  color: #ff5b5b;
  cursor: pointer;
  padding: 0.3rem;
`;

const Subject = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1.4rem;
  color: #fff;
`;

const Body = styled.div`
  font-family: "Poppins-Regular";
  font-size: 1.3rem;
  color: var(--muted, #8e8c94);
  white-space: pre-line;
  line-height: 1.5;
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(6, 6, 8, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
`;

const ConfirmBox = styled.div`
  background: var(--bg1, #101013);
  border: 1px solid var(--line2, rgba(255, 255, 255, 0.14));
  border-radius: 0.4rem;
  padding: 2rem;
  max-width: 380px;
  width: 90%;

  p {
    font-family: "Poppins-Medium";
    font-size: 1.4rem;
    color: #fff;
    margin-bottom: 1.6rem;
    text-align: center;
  }
`;

const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const Cancel = styled.div`
  padding: 0.8rem 1.6rem;
  border: 1px solid var(--line2, rgba(255, 255, 255, 0.14));
  border-radius: 0.4rem;
  color: var(--muted, #8e8c94);
  font-family: "Poppins-Medium";
  font-size: 1.3rem;
  cursor: pointer;
`;

const Confirm = styled.div`
  padding: 0.8rem 1.6rem;
  background: #fe5f55;
  border-radius: 0.4rem;
  color: #fff;
  font-family: "Poppins-SemiBold";
  font-size: 1.3rem;
  cursor: pointer;
`;
